/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  enabled?: boolean;
}

export const useGetLeads = (props: Props) => {
  const url = `${leadsWebEnviroment}/commom/leads/identificacao/v1`;

  const fetchData = async () => {
    const response = await instance.get(url);
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-leads"],
    enabled: props.enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
};
